export const getTripAnalysisKey = (date, codigo) =>
    `trip-analysis:${date}-${codigo}`;

export const getTripKey = (date, codigo) =>
    `${date}-${codigo}`;

export function parseTripUid(tripUid) {

    return {
        date: tripUid.slice(0, 10),
        codigo: tripUid.slice(11)
    };

}